app.footerController = app.footerController || {};
app.footerController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.toggleFooter();
    },

    toggleFooter : function () {
        var $toggleFooter = $('.toggleFooter'),
            $siteFooter = $('.siteFooter');

        if($toggleFooter.length > 0) {
            // HOVER toggle
            $('.toggleFooter').on('mouseover', function(){
                $siteFooter.addClass('is-hover');
            });
            $('.toggleFooter').on('mouseout', function(){
                $siteFooter.removeClass('is-hover');
            });

            // CLICK toggle
            $('.toggleFooter').on(app.clickEvent, function(){
                $siteFooter.removeClass('is-hover').toggleClass('is-active');
            });
        }
    },

};

$(document).ready(function(){
    app.footerController.defaultAction.init();
});